var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-popconfirm',{attrs:{"title":"确认删除吗？","popper-class":"scopedName","hide-icon":true},on:{"confirm":_vm.confirmDelete}},[_c('i',{staticClass:"iconfont icon-shanchu-bukexuan iconDefault",staticStyle:{"margin-left":"10px","font-size":"14px","font-weight":"700"},attrs:{"slot":"reference","title":"删除"},slot:"reference"})])
}
var staticRenderFns = []

export { render, staticRenderFns }